export const config = {
  pteAppUrl: import.meta.env.VITE_PTE_APP_URL || 'http://localhost:3000',
  pteApiUrl: import.meta.env.VITE_PTE_API_URL || 'http://localhost:8888/api',
  timeout: 10000,
};
